import { render, staticRenderFns } from "./PdfAsignation.vue?vue&type=template&id=3dca45e9"
import script from "./PdfAsignation.vue?vue&type=script&lang=js"
export * from "./PdfAsignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports